import { useStores } from '../../stores/useStores';

import { useSubscriptionData } from './useSubscriptionQueries';

export const useSubscriptionDataInitializer = () => {
  const { subscriptionStore } = useStores();

  useSubscriptionData();

  subscriptionStore.subscriptionEnabled;
};
